var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"number-formatted"},[(+_vm.number === 0)?_c('span',[_vm._v("–")]):_vm._l((_vm.parts),function(part){return _c('span',{domProps:{"textContent":_vm._s(part)}})}),_vm._v(" "),(_vm.currencySymbol && +_vm.number !== 0)?_c('span',[_vm._v(" "+_vm._s(_vm.currencySymbol))]):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5c72c7a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/number.vue
// module id = null
// module chunks = 